import React, { useState } from "react";
import data from "../../json/landingpage/herosection.json";
import { Link } from "react-router-dom";
import ProductCarousel from "./productCarousel";
import parse from "html-react-parser";

const Herosection = () => {
  const [currentItem, setCurrentItem] = useState(0);
  const handlChange = (id) => {
    setCurrentItem(id);
  };
  return (
    <>
      {/* <div className={`${currentItem === 4 ? "" : "hidden"}`}>
        <div className="herosection w-full justify-center flex ">
          <div className="2xl:container mx-auto md:px-10 lg:px-20  px-6 w-full flex  flex-col items-center lg:items-start  mt-[120px]">
            <div className="w-full flex flex-col items-center text-center sm:w-[100%] md:w-[80%] ">
              <h1 className="text-32 md:text-48 lg:text-64 text-white font-semibold">
                {data.Title}
              </h1>
              <p className="mt-4 text-base lg:text-18 text-heropara w-11/12">
                {data.Titlepara}
              </p>

              <div className="flex justify-center md:justify-start">
                <Link
                  to={"/company/contactus"}
                  className="py-[12px] lg:py-[16px] px-5 lg:px-10 hover:bg-btnhover bg-orangebg rounded-[16px] mt-12"
                >
                  <p className="text-base font-semibold text-white">
                    Get Started Now
                  </p>
                </Link>
              </div>
            </div>
            <div className="w-full flex flex-col p-8 sm:p-10 items-left text-left sm:w-[100%] md:w-[80%] lg:w-[65%] xl:w-[55%] backdrop-blur-[8px] border border-herosecborder bg-herobackground rounded-[32px]">
              <h1 className="text-32 md:text-48  text-white font-bold">
                {data.Title}
              </h1>
              <p className="mt-4 text-base lg:text-18 text-lightwhite">
                {data.Titlepara}
              </p>

              <div className="flex  justify-start">
                <Link
                  to={"/company/contactus"}
                  className="py-[12px] lg:py-[16px] px-5 lg:px-10 hover:bg-btnhover bg-orangebg rounded-[16px] mt-12"
                >
                  <p className="text-base font-semibold text-white">
                    Get Started Now
                  </p>
                </Link>
              </div>
            </div>
            <div className="mt-[90px] -mb-[10%]  hero-bottom w-full flex justify-center  relative">
              <div className="w-full bg-white">
                <ProductCarousel data={data} />
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* MARK:FirstBanner */}
      {/* <div className={`${currentItem === 4 ? "" : "hidden"}`}>
        <div className="herosection w-full justify-center flex ">
          <div className="2xl:container lg:h-[100vh] lg:max-h-[640px]  h-fit  w-full flex lg:flex-row flex-col lg:mt-0 items-center lg:pr-0 ">
            <div className="w-full px-6  sm:pl-20 sm:pr-16 sm:w-[100%] md:w-[100%] lg:w-[60%] max-[1200px]:lg:w-[55%]  text-center md:text-left hero-left flex flex-col items-center min-h-[500px] lg:min-h-[565px] justify-center h-full ">
              <div className="w-full flex flex-col items-center md:items-start">
                <h1 className="text-32 lg:text-56 text-white font-semibold">
                  {parse(data.Title)}
                </h1>
                <p className="mt-4 text-base lg:text-18 text-heropara w-11/12">
                  {parse(data.Titlepara)}
                </p>

                <div className="flex justify-center md:justify-start">
                  <Link
                    to={"/company/contactus"}
                    className="py-[12px] lg:py-[16px] px-5 lg:px-10 hover:bg-btnhover bg-orangebg rounded-[16px] mt-12"
                  >
                    <p className="text-base font-semibold text-white">
                      Get Started Now
                    </p>
                  </Link>
                </div>
              </div>
              <div className="flex gap-2  w-full justify-center">
                {Array.from({ length: 5 }).map((_, i) => (
                  <div
                    key={i}
                    className={`rounded-full cursor-pointer  border-black ${
                      currentItem === i
                        ? "bg-ctaorange h-[10px] w-[20px]"
                        : "bg-white h-[10px] w-[20px]"
                    }`}
                    onClick={() => handlChange(i)}
                  ></div>
                ))}
              </div>
            </div>
            <div className="w-full sm-w-full md:w-[100%] lg:w-[40%] max-[1200px]:lg:w-[45%] items-center  flex flex-col mb-16 md:mt-0 lg:mt-16 h-full  herorightpanel">
              <div className=" w-[80%] max-[450px]:w-full  md:w-full py-16 md:px-10 lg:px-20   lg:px-20 sm:px-16 max-[1190px]:lg:px-10  px-8 flex flex-col items-center">
                <div className="shadow-carouselarrow bg-white md:w-[50%] lg:w-full w-full">
                  <h1 className="text-base text-white bg-primarycolor p-5 font font-semibold">
                    {data.productheading}
                  </h1>
                  <div className="flex flex-col">
                    {data.products.map((el, i) => (
                      <div
                        key={i}
                        className="gap-3 justify-between p-4 border-b-[1px] border-journyborder items-center px-8 max-[1190px]:px-6 bg-white hover:bg-gray"
                      >
                        <div className="flex flex-col gap-4 mb-3">
                          <div className="h-[40px] w-[100px] rounded-full productlogo">
                            <img
                              src={process.env.PUBLIC_URL + el.icon}
                              alt="pdficon"
                              className="text-white"
                            />
                          </div>
                        </div>
                        <div className="text-primarycolor  flex flex-row gap-3 w-full productlist relative">
                          <Link to={el.url}>
                            <p className="text-16 text-primarycolor">
                              {el.productdesc}
                            </p>
                          </Link>
                          <img
                            className="w-[22px] h-[22x]"
                            src={
                              process.env.PUBLIC_URL +
                              "/images/Herosection/arrow-circle-right.svg"
                            }
                            alt="icon"
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className=" bg-white">
                    <div className="p-4 ">
                      <Link
                        to={"all/products"}
                        className="flex items-center gap-4 justify-center"
                      >
                        <p className="text-ctaorange font-semibold">
                          Explore All Product
                        </p>
                        <div className="w-[34px] h-[34px] text-orange flex items-center justify-center">
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/images/Herosection/greaterthan.svg"
                            }
                            alt="."
                          />
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* MARK:banner3 */}
      {/* <div
        className={`w-full relative mb-[25vh] ${
          currentItem === 0 ? "" : "hidden"
        }`}
      >
        <div className="2xl:container mx-auto md:px-10 lg:px-20  px-6 w-full flex  flex-col items-start mt-14 sm:mt-20  lg:mt-[100px] ">
          <h1 className=" text-32 sm:text-40 md:text-48 lg:text-56 text-primarycolor font-bold w-full lg:w-[80%]">
            {parse(data.Title)}
          </h1>
          <div className="w-full mt-10 sm:mt-20">
            <img
              className="w-full max-sm:hidden min-h-[250px]"
              src={process.env.PUBLIC_URL + "/images/Herosection/banner3.png"}
              alt="banner"
            />
            <img
              className="w-full sm:hidden max-h-[400px]"
              src={
                process.env.PUBLIC_URL + "/images/Herosection/mb-banner3.png"
              }
              alt="banner"
            />
          </div>
        </div>

        <div className=" w-full bg-productcauroselbg pt-[20%] absolute bottom-[-25vh]">
          <div className="2xl:container mx-auto px-6 md:px-10 lg:px-20 ">
            <ProductCarousel data={data} />
          </div>
        </div>
        <div className="flex gap-2 absolute bottom-[20px] w-full justify-center">
          {Array.from({ length: 4 }).map((_, i) => (
            <div
              key={i}
              className={`rounded-full cursor-pointer  border-black ${
                currentItem === i
                  ? "bg-ctaorange h-[10px] w-[20px]"
                  : "bg-white h-[10px] w-[20px]"
              }`}
              onClick={() => handlChange(i)}
            ></div>
          ))}
        </div>
      </div> */}
      {/* MARK:banner4 */}
      {/* <div className={`w-full  ${currentItem === 1 ? "" : "hidden"}`}>
        <div className="w-full max-sm:h-[450px] sm:h-[95vh] sm:max-h-[900px] bg-mbbanner sm:bg-banner bg-cover bg-center bg-no-repeat relative">
          <div className="w-full h-full 2xl:container mx-auto md:px-10 lg:px-20  px-6 flex flex-col items-center justify-end text-center w-full gap-12 pb-16">
            <h1 className="text-32 md:text-48 lg:text-56 text-white font-bold w-full">
              {parse(data.Title)}
            </h1>
            <div className="flex justify-center">
              <Link
                to={"/company/contactus"}
                className="py-[12px] lg:py-[16px] px-5 lg:px-10 hover:bg-btnhover bg-orangebg rounded-[16px]"
              >
                <p className="text-base font-semibold text-white">
                  Get Started Now
                </p>
              </Link>
            </div>
          </div>
          <div className="flex gap-2 absolute bottom-[20px] justify-center w-full">
            {Array.from({ length: 4 }).map((_, i) => (
              <div
                key={i}
                className={`rounded-full cursor-pointer  border-black ${
                  currentItem === i
                    ? "bg-ctaorange h-[10px] w-[20px]"
                    : "bg-white h-[10px] w-[20px]"
                }`}
                onClick={() => handlChange(i)}
              ></div>
            ))}
          </div>
        </div>
        <div className="w-full flex">
          <div className="hidden lg:flex w-[35%] bg-primarycolor md:pl-20 pl-6 pr-4 lg:pr-8 py-12 justify-center">
            <h2 className="text-white text-left font-semibold text-24 lg:text-32 2xl:text-36">
              End-to-End Solutions for Publishing
            </h2>
          </div>
          <div className=" w-full lg:w-[65%]  bg-productcauroselbg  lg:p-6">
            <ProductCarousel data={data} />
          </div>
        </div>
      </div> */}
      {/* MARK:banner5 */}
      {/* <div className={`w-full  ${currentItem === 2 ? "" : "hidden"}`}>
        <div className="w-full lg:min-h-[650px] 2xl:max-h-[700px] mt-[20px] relative">
          <div className="max-lg:flex max-lg:flex-col-reverse">
            <div className="business pb-12 w-full">
              <div className="2xl:container md:px-10 lg:px-20  px-6 mx-auto pt-14 sm:pt-20 ">
                <h1 className=" text-26 max-sm:text-center sm:text-40 lg:text-48  text-primarycolor relative z-[12] font-bold w-full lg:w-[55%]">
                  {parse(data.Title)}
                </h1>

                <div className="flex justify-center md:justify-start">
                  <Link
                    to={"/company/contactus"}
                    className="py-[12px] lg:py-[16px] px-5 lg:px-10 hover:bg-btnhover bg-orangebg rounded-[16px] mt-12"
                  >
                    <p className="text-base font-semibold text-white">
                      Get Started Now
                    </p>
                  </Link>
                </div>
              </div>
            </div>
            <div className="lg:w-[55vw]  lg:h-[80vh] lg:min-h-[650px] 2xl:max-h-[701px] lg:absolute top-0 right-0 banner-video z-[10] lg:overflow-hidden">
              <video
                src={
                  process.env.PUBLIC_URL +
                  "/images/video/banner-video.mp4"
                }
                autoPlay
                muted
                loop
                playsInline
                className="w-full h-full object-fill block m-0 p-0"
              />
              <div className="flex gap-2 absolute bottom-[20px] justify-center w-full">
                {Array.from({ length: 4 }).map((_, i) => (
                  <div
                    key={i}
                    className={`rounded-full cursor-pointer  border-black ${
                      currentItem === i
                        ? "bg-ctaorange h-[10px] w-[20px]"
                        : "bg-white h-[10px] w-[20px]"
                    }`}
                    onClick={() => handlChange(i)}
                  ></div>
                ))}
              </div>
            </div>
          </div>
          <div className=" 2xl:container lg:px-20  w-full mx-auto z-[11] relative ">
            <div className="bg-white w-full shadow-products px-3">
              <ProductCarousel data={data} />
            </div>
          </div>
        </div>
      </div> */}
      {/* MARK:banner6 */}
      {/* <div className={`w-full  ${currentItem === 3 ? "" : "hidden"}`}>
        <div className="w-full max-sm:h-[450px] h-[85vh] sm:max-h-[900px] bg-mbbanner sm:bg-banner bg-cover bg-center bg-no-repeat relative">
          <div className="w-full h-full 2xl:container md:px-10 lg:px-20  px-6 mx-auto flex flex-col md:items-start justify-center md:justify-end items-center text-center md:text-left w-full gap-12 pb-16">
            <h1 className="text-32 md:text-48 lg:text-56 text-white font-bold w-full sm:w-[90%] 2xl:w-[80%]">
              {parse(data.Title)}
            </h1>
          </div>
          <div className="flex gap-2 absolute bottom-[20px] justify-center w-full">
            {Array.from({ length: 4 }).map((_, i) => (
              <div
                key={i}
                className={`rounded-full cursor-pointer  border-black ${
                  currentItem === i
                    ? "bg-ctaorange h-[10px] w-[20px]"
                    : "bg-white h-[10px] w-[20px]"
                }`}
                onClick={() => handlChange(i)}
              ></div>
            ))}
          </div>
        </div>
        <div className="w-full flex">
          <div className=" w-full   bg-productcauroselbg  lg:p-6">
            <ProductCarousel data={data} />
          </div>
        </div>
      </div> */}

      {/* MARK:banner final */}

      {/* <div className={`w-full md:mb-[64px]`}>
        <div className="w-full lg:min-h-[700px] 2xl:max-h-[730px] mt-[20px] relative">
          <div className="max-lg:flex max-lg:flex-col lg:h-[80vh] lg:min-h-[700px] 2xl:max-h-[730px]">
            <div className="bg-Darkblue pb-[68px] pt-10 flex justify-start h-full w-full">
              <div className=" 2xl:container mx-auto  md:pl-20 px-6 2xl:pt-10 w-full">
                <h1 className="hero-section-title text-26 max-sm:text-center sm:text-32 lg:w-[40%] 2xl:w-[40%]  text-white relative z-[12] font-regular w-full ">
                  {parse(data.Title)}
                </h1>

                <div className="flex justify-center sm:justify-start">
                  <Link
                    to={"/company/contactus"}
                    className="py-[12px] lg:py-[14px] px-5 lg:px-8 hover:bg-btnhover bg-orangebg rounded-[16px] mt-10 2xl:mt-12"
                  >
                    <p className="text-base font-semibold text-white">
                      Get Started Now
                    </p>
                  </Link>
                </div>
              </div>
            </div>
            <div className="lg:w-[55vw]  lg:h-[80vh] lg:min-h-[700px] 2xl:max-h-[730px] lg:absolute top-0 right-0 banner-video z-[10] lg:overflow-hidden">
              <img
                className="w-full h-full "
                src={
                  process.env.PUBLIC_URL +
                  "/images/Herosection/hero-banner2.gif"
                }
                alt="banner_img"
              />
            </div>
            <div className="w-full pt-20 bottom-0  z-[11] absolute md:-bottom-[64px] ">
              <div className="2xl:container mx-auto  xl:px-20">
                <div className="bg-white  w-full  shadow-products px-3">
                  <ProductCarousel data={data} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div className="w-full flex flex-col justify-center">
        <div className=" w-full relative h-[300px] sm:h-[500px] lg:h-[720px] overflow-hidden flex items-center justify-center ">
          <div className="h-[300px] sm:h-[500px] lg:h-[720px] absolute top-0 -z-10 w-full">
            <video
              className="h-fullw-full h-full"
              id="backgroundvideo"
              autoPlay
              muted
              loop
            >
              <source
                src={data.videourl}
                type="video/mp4"
                className="h-full w-full"
              />
            </video>
            <div className="absolute inset-0 bg-[rgba(0,0,0,0.5)] md:bg-[linear-gradient(180deg,rgba(0,0,0,0)_20.07%,#000000_100.21%)]"></div>
          </div>
          <div className="relative z-10 w-10/12 lg:w-8/12 flex flex-col mt-auto bottom-[10%] md:bottom-[14%] text-center items-center gap-5 md:gap-12">
            <h1 className="text-base sm:text-32 lg:text-48 text-white">
              {parse(data.title)}
            </h1>
            {/* <div className="h-[1px] w-[10%] bg-button"></div> */}
            <Link to={"/company/contactus"}>
              <button className="w-fit font-medium text-16 sm:text-18 text-white px-[20px] py-[9px] md:px-[25px] md:py-[13px] bg-orangebg rounded-[12px] sm:rounded-[16px] flex items-center hover:bg-btnhover hover:bg-box-shadow:inset 5px -5px 4px #D73B00">
                Get Started Now
              </button>
            </Link>
          </div>
        </div>
        <div className="w-full">
          <div className="w-full md:w-[80%] md:w-full flex mx-auto items-center 2xl:items-stretch  bg-[rgba(239,238,255,.61)]">
            <div className="hidden lg:flex items-center px-14 py-8 w-[25%]  bg-[#202138]">
              <p className="font-bold text-white text-20  lg:text-24">
                Solutions for publishing & content
              </p>
            </div>
            <div className="bg-white w-full lg:w-[75%]">
              <ProductCarousel data={data} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Herosection;
